export const generatePassword = (): string => {
    const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lower = 'abcdefghijklmnopqrstuvwxyz';
    const digits = '0123456789';
    const symbols = '!@#$%^&*';
    const all = upper + lower + digits + symbols;
    let pwd =
        upper[Math.floor(Math.random() * upper.length)] +
        lower[Math.floor(Math.random() * lower.length)] +
        digits[Math.floor(Math.random() * digits.length)] +
        symbols[Math.floor(Math.random() * symbols.length)];
    for (let i = 4; i < 12; i++) {
        pwd += all[Math.floor(Math.random() * all.length)];
    }
    return pwd.split('').sort(() => Math.random() - 0.5).join('');
};

/**
 * remove all html tags from a string
 * keep new line using \n on each <p> tag
 * keep bullet point using - and \n on each <li> tag
 * keep number list using 1. and \n on each <li> tag
 * @param html 
 */
export const sanitizeHtml = (str?: string) => {
  if (!str) return '';
  let html = str;
  // make the html into one line
  html = html.replace(/\n/g, '');

  html = removeBulletPoint(html);
  html = removeNumberList(html);
  html = removeIndentation(html);

  html = html.replace(/<\/h[1-6]>/g, '\n');
  html = html.replace(/<h[1-6]>/g, '');

  html = removeEmojis(html);

  // keep new line using \n on each <p> tag
  html = html.replace(/<\/p>/g, '\n');
  html = html.replace(/<p>/g, '');

  // remove all html tags
  html = html.replace(/<[^>]*>?/gm, '');

  // replace multiple new lines with single new line, even if there are spaces for example: \n \n \n
  html = html.replace(/\n{2,}/g, '\n');

  // remove tabs or multiple spaces
  html = html.replace(/ {2,}/g, '');

  return html;
}

const removeEmojis = (str: string) => {
  return str.replace(/’/g, "'").replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
}

const removeIndentation = (str: string) => {
  // find p with className ql-indent-{number},
  // and then replace it with \t depending on the number
  let html = str;
  const indentRegex = /<p class="ql-indent-(\d)">([\s\S]*?)<\/p>/g;
  const indentMatch = html.match(indentRegex);
  if (indentMatch) {
    indentMatch.forEach((indent) => {
      const indentNumber = indent.match(/ql-indent-(\d)/)[1];
      html = html.replace(indent, indent.replace(/<p class="ql-indent-\d">/g, '\t'.repeat(parseInt(indentNumber))).replace(/<\/p>/g, '\n'));
    });
  }
  return html;
}

const removeBulletPoint = (str: string) => {
  let html = str;
  // find <ul> tag
  const ulRegex = /<ul>([\s\S]*?)<\/ul>/g;
  const ulMatch = html.match(ulRegex);
  if (ulMatch) {
    ulMatch.forEach((ul) => {
      // find <li> tag
      const liRegex = /<li>([\s\S]*?)<\/li>/g;
      const liMatch = ul.match(liRegex);
      let _ul = ul;
      if (liMatch) {
        liMatch.forEach((li) => {
          // replace <li> tag with -
          // html = html.replace(li, li.replace(/<li>/g, '- ').replace(/<\/li>/g, '\n'));
          _ul = _ul.replace(li, li.replace(/<li>/g, '- ').replace(/<\/li>/g, '\n'));
        });
        html = html.replace(ul, _ul);
      }
    });
  }

  html = html.replace(/<\/ul>/g, '\n');
  html = html.replace(/<ul>/g, '');
  return html;
}

const removeNumberList = (str: string) => {
  let html = str;
  // find <ol> tag
  const olRegex = /<ol>([\s\S]*?)<\/ol>/g;
  const olMatch = html.match(olRegex);
  if (olMatch) {
    olMatch.forEach((ol) => {
      // find <li> tag
      const liRegex = /<li>([\s\S]*?)<\/li>/g;
      const liMatch = ol.match(liRegex);
      let _ol = ol;
      if (liMatch) {
        liMatch.forEach((li, index) => {
          // replace <li> tag with -
          // html = html.replace(li, li.replace(/<li>/g, `${index + 1}. `).replace(/<\/li>/g, '\n'));
          _ol = _ol.replace(li, li.replace(/<li>/g, `${index + 1}. `).replace(/<\/li>/g, '\n'));
        });
        html = html.replace(ol, _ol);
      }
    });
  }

  html = html.replace(/<\/ol>/g, '\n');
  html = html.replace(/<ol>/g, '');
  return html;
}
